import { useEffect } from "react";
import "../styles/faq.scss";

const Faqcia = () => {
    useEffect(() => {
        const accordions = document.querySelectorAll(
            "#accordionCIA .accordion-button"
        );

        const handleClick = function () {
            const target = this.getAttribute("data-bs-target");
            const collapse = document.querySelector(target);

            if (!collapse) return;

            if (collapse.classList.contains("show")) {
                collapse.classList.remove("show");
            } else {
                collapse.classList.add("show");
            }
        };

        accordions.forEach((accordion) => {
            accordion.addEventListener("click", handleClick);
        });

        return () => {
            accordions.forEach((accordion) => {
                accordion.removeEventListener("click", handleClick);
            });
        };
    }, []);

    const faqSections = [
        {
            title: "一、CIA 的價值與職涯方向",
            items: [
                {
                    q: "什麼是 CIA？",
                    a: (
                        <>
                            CIA（Certified Internal Auditor，國際內部稽核師）由國際內部稽核協會（IIA）頒發，是全球認可的內部稽核專業證照，用來證明持證者具備執行內部稽核服務所需的知識、技能與能力。這是一張專業證照，非政府核發執照。
                        </>
                    ),
                },
                {
                    q: "CIA 的國際辨識度如何？",
                    a: (
                        <>
                            根據 IIA 官方資料顯示，全球已有超過 22 萬名 CIA，分布於 170 個以上國家。其核心價值是以《全球內部稽核準則》為共同專業語言，方便跨國企業辨識內部稽核、風險管理與內部控制能力。
                        </>
                    ),
                },
                {
                    q: "哪些人適合考 CIA？",
                    a: (
                        <>
                            適合內部稽核、外部查核、會計、風險管理、內部控制、法遵、資訊稽核、營運改善及公司治理相關從業人員；也適合希望由財會職能轉往企業稽核、風控或治理職能者。
                        </>
                    ),
                },
                {
                    q: "取得 CIA 後可發展哪些工作？",
                    a: (
                        <>
                            常見方向包括內部稽核人員、稽核主管或內部稽核主管（CAE），以及企業風險管理、內部控制、法遵、公司治理、確信服務、資訊科技風險與資料分析等職務。實際職位仍取決於個人經驗、產業與技能組合。
                        </>
                    ),
                },
                {
                    q: "CIA 與 CPA 兩張證照有重疊之處嗎？",
                    a: (
                        <>
                            兩者為互補，用途不重疊。CPA 較著重財務會計、財務報導、外部查核、稅務與法規；CIA 聚焦內部稽核、公司治理、風險管理、內部控制，以及確信與顧問服務。兩者的互補性，特別適合希望從財會或外部查核延伸至企業內稽、風控與治理的人。
                        </>
                    ),
                },
                {
                    q: "AI 時代下，CIA 還有價值嗎？",
                    a: (
                        <>
                            極具價值。現行 CIA 考綱已納入人工智慧、機器學習、流程機器人自動化、儀表板、資料分析、資安與資料隱私等議題。CIA 的重點不是培養程式設計師，而是訓練專業人員評估科技風險、治理、控制與稽核證據。
                        </>
                    ),
                },
                {
                    q: "考到 CIA 就一定能加薪或升遷嗎？",
                    a: (
                        <>
                            CIA 可強化國際企業重視（且常指定考取）的專業可信度、與職涯辨識度，薪資與升遷則取決於地區、產業、職務、年資及實務表現。
                        </>
                    ),
                },
            ],
        },

        {
            title: "二、CIA 三科路徑與 Challenge Exam（挑戰考試）怎麼選？",
            items: [
                {
                    q: "CIA 三科考試與 Challenge Exam（挑戰考試）最大差別是什麼？",
                    a: (
                        <>
                            CIA 一般考試（三科路徑）把內部稽核基礎、單一稽核案執行及內部稽核部門管理分開測驗；Challenge Exam（挑戰考試）則把三科重點濃縮為一場 150 題、180 分鐘的考試。
                        </>
                    ),
                },
                {
                    q: "哪些人可報考 CIA Challenge Exam（挑戰考試）？",
                    a: (
                        <>
                            目前主要有三條資格路徑：
                            <ol>
                                <li>
                                    持有有效且列於 IIA 名單的 CPA／CA（例如美國註冊會計師 active license）。
                                </li>
                                <li>持有有效 CISA。</li>
                                <li>
                                    具至少 10 年內部稽核或相關經驗的專業人士。
                                </li>
                            </ol>
                            前兩類全年開放申請；10 年經驗路徑為 2026 年試辦方案。
                        </>
                    ),
                },
                {
                    q: "只有通過美國 CPA 考試、或持 inactive CPA license，可以報考 Challenge Exam（挑戰考試）嗎？",
                    a: (
                        <>
                            不行。Challenge Exam（挑戰考試）的報考資格指定需持有有效（active）的美國 CPA 資格。美國 CPA 須為任一州 Board 核發的有效執照，並提供有效執照或 good standing 證明；僅通過考試或持 inactive license 皆無法符合。
                        </>
                    ),
                },
                {
                    q: "只有台灣會計師資格，可以報考 Challenge Exam（挑戰考試）嗎？",
                    a: (
                        <>
                            截至 2026 年 8 月底，IIA 公布的 approved accounting bodies 名單未列中華民國會計師資格。
                        </>
                    ),
                },
                {
                    q: "美國 CPA 走 Challenge Exam（挑戰考試）路徑，還需要另外證明內稽工作經驗嗎？",
                    a: (
                        <>
                            不需要。IIA 明確表示，Challenge Program 不要求另交工作經驗證明；但申請者必須維持符合資格的專業證照為有效狀態，並完成所需驗證。
                        </>
                    ),
                },
                {
                    q: "兩條路徑取得的 CIA 證照有差別嗎？",
                    a: (
                        <>
                            沒有。Challenge Exam（挑戰考試）是取得 CIA 的另一種考試路徑；完成後取得的同樣是 CIA 證照，不會另標示為較低階或不同版本。
                        </>
                    ),
                },
                {
                    q: "Challenge Exam（挑戰考試）只有一科，是否代表比較簡單？",
                    a: (
                        <>
                            不一定。它雖然少考兩科，但一次涵蓋三科核心內容，且 IIA 強調會測驗內部稽核知識的進階實務應用。優勢是考試路徑較短，不代表準備量可以忽略。
                        </>
                    ),
                },
                {
                    q: "哪一條路徑比較適合我？",
                    a: (
                        <>
                            <p>
                                沒有合格 CPA／CA、CISA 或 10 年相關經驗者，應選擇三科路徑。
                            </p>
                            <p>
                                已符合 Challenge 資格、希望快速完成，且能承受一次長考者，可選擇 Challenge Exam（挑戰考試）。
                            </p>
                            <p>
                                若希望分科建立完整基礎，或必須用繁體中文應試，三科路徑通常更合適。
                            </p>
                        </>
                    ),
                },
            ],
        },

        {
            title: "三、考試內容、題型、語言與考場",
            items: [
                {
                    q: "CIA 三科各考什麼？題數與時間是多少？",
                    a: (
                        <>
                            <p>
                                三科皆為電腦化選擇題，內容由基礎到單一稽核案，再延伸至內部稽核部門的管理與報告。
                            </p>

                            <p>
                                <strong>
                                    Part 1：Internal Audit Fundamentals／內部稽核基礎
                                </strong>
                            </p>
                            <ul>
                                <li>
                                    主要內容：內稽基礎、倫理與專業、治理／風險／控制、舞弊風險
                                </li>
                                <li>題數：125 題</li>
                                <li>時間：150 分鐘</li>
                            </ul>

                            <p>
                                <strong>
                                    Part 2：Internal Audit Engagement／內部稽核案件
                                </strong>
                            </p>
                            <ul>
                                <li>
                                    主要內容：案件規劃、資料蒐集與分析、評估、督導與溝通
                                </li>
                                <li>題數：100 題</li>
                                <li>時間：120 分鐘</li>
                            </ul>

                            <p>
                                <strong>
                                    Part 3：Internal Audit Function／內部稽核職能
                                </strong>
                            </p>
                            <ul>
                                <li>
                                    主要內容：內稽營運、稽核計畫、品質、結果溝通與追蹤
                                </li>
                                <li>題數：100 題</li>
                                <li>時間：120 分鐘</li>
                            </ul>
                        </>
                    ),
                },
                {
                    q: "Challenge Exam（挑戰考試）考什麼？",
                    a: (
                        <>
                            現行考綱分為五大領域：
                            <ul>
                                <li>內部稽核專業與品質：20%</li>
                                <li>內稽營運與稽核計畫：15%</li>
                                <li>案件規劃：20%</li>
                                <li>案件執行：25%</li>
                                <li>結果溝通與追蹤：20%</li>
                            </ul>
                            全科共 150 題，考試時間為 180 分鐘。
                        </>
                    ),
                },
                {
                    q: "考試都是選擇題嗎？如何判定通過？",
                    a: (
                        <>
                            是，CIA 三科與 Challenge Exam（挑戰考試）均為電腦化選擇題。IIA 採量尺分數（scaled score），600 分為通過標準；600 分不代表單純答對 60%。
                        </>
                    ),
                },
                {
                    q: "可以用中文考試嗎？",
                    a: (
                        <>
                            <p>
                                CIA 三科提供繁體中文、英文等多種語言。
                            </p>
                            <p>
                                Challenge Exam（挑戰考試）目前提供英文、法文與西班牙文；目前無提供用中文應考。
                            </p>
                        </>
                    ),
                },
                {
                    q: "台灣有考場嗎？可以在家線上考嗎？",
                    a: (
                        <>
                            <p>
                                考試須在 Pearson VUE 授權考場，現場進行考試。
                            </p>
                            <p>
                                台灣考生可透過 CCMS 連至 Pearson VUE，查詢可用城市、日期與地址。實際考場及考位會依預約狀況變動。
                            </p>
                        </>
                    ),
                },
                {
                    q: "考試全年都能考嗎？",
                    a: (
                        <>
                            <p>
                                CIA 三科路徑沒有 Challenge Exam（挑戰考試）的四個固定考試視窗。考生可在考試授權有效期內，依 Pearson VUE 可用考位預約。
                            </p>
                            <p>
                                Challenge Exam（挑戰考試）僅於 2 月、6 月、9 月及 11 月的考試視窗提供。（實際開放時間，請依照官方考場單位公告為準。）
                            </p>
                        </>
                    ),
                },
                {
                    q: "考完多久會收到成績？",
                    a: (
                        <>
                            IIA 現行說明為考試日起三週內收到單一正式成績，成績可用後會以系統電子郵件通知。Challenge Exam（挑戰考試）自 2026 年 9 月考試視窗起亦採此作法。
                        </>
                    ),
                },
                {
                    q: "CIA 三科一定要照 Part 1、2、3 的順序考嗎？",
                    a: (
                        <>
                            不用。IIA 不規定應考順序；考生可依自己的背景、備考計畫與考試授權安排科目。
                        </>
                    ),
                },
            ],
        },

        {
            title: "四、資格、報名、時限與費用",
            items: [
                {
                    q: "CIA 三科路徑的學歷與工作經驗要求是什麼？",
                    a: (
                        <>
                            <p>
                                碩士或同等以上學歷通常需 1 年相關經驗；學士或同等學歷需 2 年。
                            </p>
                            <p>
                                可認列領域包括內部稽核、品質保證、風險管理、查核／評估、法遵、外部查核及內部控制。無學位者可先走 IAP 路徑，之後依規定完成 CIA 與經驗要求。
                            </p>
                        </>
                    ),
                },
                {
                    q: "還沒有足夠工作經驗，可以先考 CIA 嗎？",
                    a: (
                        <>
                            可以。碩士與學士路徑可先應考，再於三年計畫期限內完成經驗驗證。只有通過考試、尚未完成其他要求時，仍不能宣稱已取得 CIA。
                        </>
                    ),
                },
                {
                    q: "報名流程怎麼走？",
                    a: (
                        <>
                            <ol>
                                <li>在 CCMS 建立帳號。</li>
                                <li>
                                    提交 Program 申請、身分證明及學歷或專業資格文件。
                                </li>
                                <li>
                                    申請核准後，在 CCMS 登記並繳交考試費。
                                </li>
                                <li>
                                    由 CCMS 進入 Pearson VUE，選擇日期、時間與考場。
                                </li>
                            </ol>
                        </>
                    ),
                },
                {
                    q: "有哪些重要期限？",
                    a: (
                        <>
                            <p>
                                申請費完成後，通常有 90 天補齊申請文件。
                            </p>
                            <p>
                                Program 核准後，CIA 或 Challenge Program 原則上須於 3 年內完成。每次考試登記有效 180 天，或至計畫到期日，以較早者為準。
                            </p>
                            <p>
                                Challenge Program 不提供 Program 或考試延期。
                            </p>
                        </>
                    ),
                },
                {
                    q: "未通過可以重考嗎？改期或退費規定如何？",
                    a: (
                        <>
                            <p>
                                同一科在 Program 期間最多可應試 8 次；一般最早可在前次考試 30 天後重考，Challenge Exam（挑戰考試）另受固定考試視窗限制。
                            </p>
                            <p>
                                改期須於預約時間至少 48 小時前辦理，Pearson VUE 每次收取 75 美元。完成購買後原則上不退費、不可轉讓。
                            </p>
                        </>
                    ),
                },
                {
                    q: "Challenge Exam（挑戰考試）一定比較省錢嗎？",
                    a: (
                        <>
                            <p>
                                不一定。它能減少考試科數與可能的準備時間，但依 IIA 現行全球牌價，兩條路徑的官方申請及考試費總額相近。
                            </p>

                            <p>
                                現行於台灣考試價格：
                            </p>

                            <p>
                                <strong>
                                    CIA 三科：報名費加三科考試費
                                </strong>
                            </p>

                            <ul>
                                <li>
                                    報名費：會員 120 美元，學生 65 美元，非會員 240 美元。
                                </li>
                                <li>
                                    考試費：請依 IIA 台灣最新公告及 CCMS 顯示金額為準。
                                </li>
                            </ul>

                            <p>
                                CIA 三科費用來源：
                                {" "}
                                <a
                                    href="https://www.iia.org.tw/news_detail.aspx?news_id=3622"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    IIA Taiwan
                                </a>
                            </p>

                            <p>
                                <strong>
                                    Challenge Exam（挑戰考試）：報名費加一次考試費
                                </strong>
                            </p>

                            <ul>
                                <li>
                                    報名費：US$150（會員）、US$380（非會員）
                                </li>
                                <li>
                                    考試費：US$845（會員）、US$1,245（非會員）
                                </li>
                            </ul>

                            <p>
                                Challenge Exam 費用來源：
                                {" "}
                                <a
                                    href="https://www.iia.org.tw/news_more_detail.aspx?news_item=03&news_id=3725"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    IIA Taiwan
                                </a>
                            </p>

                            <p>
                                以上為 IIA 近期公告價格；實際價格、稅費與會員規則，應以 CCMS 或當地 IIA 顯示為準。以上未包含會員年費、教材、備考課程及改期費。
                            </p>
                        </>
                    ),
                },
                {
                    q: "報名費或考試費有包含教材嗎？",
                    a: (
                        <>
                            沒有。IIA 明確說明，教材不包含在申請或考試登記費中。考綱與部分官方資源可免費查閱，題庫或備考課程需另外取得。
                        </>
                    ),
                },
                {
                    q: "通過考試後，多久可以拿到 CIA？",
                    a: (
                        <>
                            <p>
                                CIA 三科路徑還須完成學歷與工作經驗驗證；Challenge 路徑則不需提供工作經驗驗證。
                            </p>
                            <p>
                                所有要求完成後，IIA 會進行最終審核，通常約 7 至 14 個工作天後，可於 CCMS 看到資格並下載電子證書。
                            </p>
                        </>
                    ),
                },
                {
                    q: "取得 CIA 後需要持續進修嗎？",
                    a: (
                        <>
                            <p>
                                需要。實際從事內稽或相關工作的 CIA，每年通常需完成 40 小時 CPE；非執業者為 20 小時。
                            </p>
                            <p>
                                兩者皆包含每年至少 2 小時倫理訓練，並須依規定完成年度續證（renewal）。
                            </p>
                        </>
                    ),
                },
            ],
        },
    ];

    let questionNumber = 0;

    return (
        <>
            <div className="accordion" id="accordionCIA">
                {faqSections.map((section, sectionIndex) => {
                    return (
                        <div key={sectionIndex}>
                            <h4 className="titlename mt-5 mb-3">
                                {section.title}
                            </h4>

                            {section.items.map((item) => {
                                questionNumber += 1;

                                const currentNumber = questionNumber;
                                const headingId =
                                    "ciaHeading" + currentNumber;
                                const collapseId =
                                    "ciaCollapse" + currentNumber;

                                return (
                                    <div
                                        className="accordion-item"
                                        key={currentNumber}
                                    >
                                        <h2
                                            className="accordion-header"
                                            id={headingId}
                                        >
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={
                                                    "#" + collapseId
                                                }
                                                aria-expanded="false"
                                                aria-controls={collapseId}
                                            >
                                                Q{currentNumber}：{item.q}
                                            </button>
                                        </h2>

                                        <div
                                            id={collapseId}
                                            className="accordion-collapse collapse"
                                            aria-labelledby={headingId}
                                            data-bs-parent="#accordionCIA"
                                        >
                                            <div className="accordion-body">
                                                A：
                                                <br />
                                                {item.a}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default Faqcia;
